import Image from "next/image";
import systemNoticeImg from "../../../public/images/dashboard/system-notice.png";
import {Tooltip} from "@chakra-ui/react";
import {BsPinAngle} from "react-icons/bs";
import {PiArrowRight} from "react-icons/pi";
import React from "react";
import Link from "next/link";
import {motion} from "framer-motion";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(advancedFormat);

export const NoticeItem = ({notice, index, exitIndex}) => (
  <motion.div
    initial={{opacity: 0, y: -10}}
    animate={{
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 24,
        delay: index * 0.05,
      }
    }}
    exit={{
      opacity: 0,
      y: -10,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 24,
        delay: exitIndex * 0.05,
      }
    }}>
    <Link
      prefetch={false}
      href={notice.link ? notice.link : ""}
      scroll={!!notice.link}
      key={notice.id}
      className='flex flex-col p-4 bg-white hover:bg-brand-off/50 cursor-pointer transition'>
      <div className='flex items-start gap-3'>
        <div className='h-full flex items-start'>
          <div className='w-[66px] h-[66px] relative rounded overflow-hidden'>
            <Image
              src={notice.image ?? systemNoticeImg}
              fill
              className='object-cover'
              alt={notice.title}/>
          </div>
        </div>
        <div className='flex flex-col flex-1 items-start'>
          <div className='flex gap-2 items-center w-full'>
            <span className='font-bold text-brand-text text-left'>{notice.title}</span>
            {notice.pinned ? (
              <Tooltip label='Pinned'>
                <div className='text-green-500'>
                  <BsPinAngle/>
                </div>
              </Tooltip>
            ) : null}
          </div>
          <span className='text-xs flex justify-end text-gray-400 pb-1.5'>
            {dayjs(notice.createdAt).format('Do MMM YYYY HH:mm')}
          </span>
          <span className='text-left font-light text-sm'>{notice.content}</span>
        </div>
        {notice.link && (
          <div className='h-full flex items-center self-center'>
            <div className='w-6 h-6 bg-brand rounded-full flex items-center justify-center text-white'>
              <PiArrowRight className='h-5 w-5'/>
            </div>
          </div>
        )}
      </div>
    </Link>
  </motion.div>
);
